
import { useEffect, useState } from "react";
import { E_immatriculation } from "../../../../constants/constant";
import { RiArrowGoBackFill} from "react-icons/ri";
import Checkbox from "../../../../components/button/Checkbox";
import axios from "axios";
import Label from "../../../../components/title/label";
import Input from "../../../../components/input/Input";
import Select from "../../../../components/input/SelectInput";
import Table from "../../../../components/table/Table";
import { MdOpenInNew } from "react-icons/md";

import { Link } from "react-router-dom";
import { Navbar } from "../../../../components/navbar/Navbar";
import BackButton from "../../../../components/button/BackButton";

function EtablissementContribuable() {


  
    const [TableEtablissement , setTableEtablissement ] = useState([]);
    const [Etablissement , setEtablissement] = useState([]);
    const [add , setAdd] = useState(false);
    const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
   
    const [ContribuableData] = useState(
    JSON.parse(selectedData )
  );
  
  const filterId = ContribuableData.id
  
    const Fokontany = [
      "MANGA",
      "AMBOVOALANANA", 
      "TSARAMANDROSO AMBANY",    
      "TSARAMANDROSO AMBONY",
       "MAHAVOKY SUD",
       "MANJARISOA",
       "MORAFENO",
       "MAHABIBOKELY",
        "ABATTOIR MAROVATO",
        "MANGARIVOTRA",
        "ARANTA",
        "ANTANIMASAJA",
        "MAHATSINJO",
        "TANAMBAO SOTEMA",
         "AMBOHIMANDAMINA",
          "ANTANIMALANDY",
          "AMBONDRONA",
          "FIOFIO",
          "AMBALAVOLA",
          "ANTANAMBAO AMBALAVATO",
          "TSARARANO AMBONY",
         "TSARARANO ANOSIKELY",
          "TSARARANO AMBANY",
          "AMBOROVY",
          "MAHAVOKY NORD",
         
  ]
  
  
    // Etablissement table 
   const Headersetablissement  = ["activité" ,"adresse" , "commune" ,"fokontany" , "district", "province" , "date ouverture", "email" , "fax", "identifiant contribuable" , "nom commercial" ,"proprietaire local" , "region" , "téléphone" , "titre" ]
   const DataEtablissment = Etablissement ? Etablissement.map((item )=>[item.activite , item.adresse , item.commune , item.fokontany , item.district , item.province ,item.date_ouverture , item.email , item.fax , item.id_contribuable , item.nom_commercial , <Checkbox checked={item.proprietaire_local} ></Checkbox> , item.region , item.telephone_1 , item.titre ]) : [["Aucun" ,"Aucun" , "Aucun" ,"Aucun" , "Aucun", "Aucun" , "Aucun", "Aucun" , "Aucun", "Aucun" , "Aucun" ,"Aucun" , "Aucun" , "Aucun" , "" ,"" , ""]];
  
  
  // data selected Etablissement  table 
  const [selectedRowIndexEtablissement, setSelectedRowIndexEtablissement] = useState(null);
  const [DataSelectedEtablisement, setDataSelectedEtablissment] = useState([]);
  
  
  const [isStorageUpdatedEtablissement, setIsStorageUpdatedEtablissement] = useState(false);
  
    
  
  useEffect(() => {
    // Récupérer les données depuis le backend
    axios.get(`${E_immatriculation}/etablissement/modelTemp`)
      .then((response) => setTableEtablissement(response.data))
      .catch((error) => {console.error(error)});
  }, []);
  
  
  useEffect(() => {
    const filteredData = TableEtablissement.filter((item) =>
      item.id_contribuable?.toString().includes(filterId)
    );
    setEtablissement(filteredData);
  }, [TableEtablissement , filterId]);
  
  
  console.log("Etablissement get : ", TableEtablissement);
  
  
  
  useEffect(() => {
       console.log(DataSelectedEtablisement)
       setIsStorageUpdatedEtablissement(false);
    }, [DataSelectedEtablisement, isStorageUpdatedEtablissement]);
    
    const handleSelectedDataTableEtablissment = (rowIndex) => {
      // Check if the clicked row is already selected
      const isRowSelected = rowIndex === selectedRowIndexEtablissement;
    
      // If the row is selected, unselect it
      if (isRowSelected) {
        setSelectedRowIndexEtablissement(null);
        setDataSelectedEtablissment([]);
      } else {
        // If the row is not selected, select it
        setSelectedRowIndexEtablissement(rowIndex);
        const selectedRowDataEtablissment = TableEtablissement[rowIndex];
        setDataSelectedEtablissment(selectedRowDataEtablissment);
      }
    
      console.log("selected :", DataSelectedEtablisement);
    };
  
  
  
    
  
     

    // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className="text-white">
        Etablissement
     </div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
    return (
       <div className={`w-full bg-[#212122] ${ add === true ? "h-full" : "h-screen" }`}>
            <Navbar content={contentNavbar} />
            <main className="">  <div >
    

   
      <div className="flex justify-center p-4">
       <div className="flex flex-col">
       { add === true && ( 
              <div className="p-4">
    
    
      <>
      <div className="flex justify-between mt-6">
        <Label text="Nom commercial"></Label>
        <Input type="text"
        value={DataSelectedEtablisement? DataSelectedEtablisement.nom_commercial : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , nom_commercial : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Activité"></Label>
        <Input type="text"
        value={DataSelectedEtablisement?DataSelectedEtablisement.activite : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , activite : e.target.value})}
        ></Input>
      </div>
     
      <div className="flex justify-between mt-6">
        <Label text="Date Ouverture "></Label>
        <Input type="date"
        value={DataSelectedEtablisement?DataSelectedEtablisement.date_ouverture : ""}
        onChange={(e)=>setDataSelectedEtablissment({...DataSelectedEtablisement , date_ouverture : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Adresse  / Lot "></Label>
        <Input type="text"
        value={DataSelectedEtablisement?DataSelectedEtablisement.adresse : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , adresse : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Fokontany "></Label>        
        <Select
        options={Fokontany.map((option) => ({ value: option, label: option }))}
        value={DataSelectedEtablisement.fokontany}
        onChange={(options) => {setDataSelectedEtablissment({...DataSelectedEtablisement , fokontany: options})}}    
        className=""
      />
  
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Province "></Label>
        <Input type="text"
        value={DataSelectedEtablisement?DataSelectedEtablisement.province : ""}
        onChange={(e)=>setDataSelectedEtablissment({...DataSelectedEtablisement , province : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Région  "></Label>
        <Input type="text"
        value={DataSelectedEtablisement ? DataSelectedEtablisement.region : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , region : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="District  "></Label>
        <Input type="text"
        value={DataSelectedEtablisement?DataSelectedEtablisement.district : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , district : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Commune "></Label>
        <Input type="text"
        value={DataSelectedEtablisement? DataSelectedEtablisement.commune : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , commune : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Téléphone   "></Label>
        <Input type="text"
        value={DataSelectedEtablisement? DataSelectedEtablisement.telephone_1 : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , telephone_1 : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Autre Téléphone "></Label>
        <Input type="text"
        value={DataSelectedEtablisement? DataSelectedEtablisement.autre_telephone : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , autre_telephone : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="Fax "></Label>
        <Input type="text"
        value={DataSelectedEtablisement? DataSelectedEtablisement.fax : ""}
        onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , fax : e.target.value})}
        ></Input>
      </div>
      <div className="flex justify-between mt-6">
        <Label text="E-mail "></Label>
        <Input type="text"
        value={DataSelectedEtablisement? DataSelectedEtablisement.email : ""}
         onChange={(e)=> setDataSelectedEtablissment({...DataSelectedEtablisement , email : e.target.value})}
        ></Input>
      </div>
      
     
      <div className="flex justify-between mt-6">
              <Label text="Propriétaire du local" />
        <div className="flex justify-between w-[200px]">
      <Checkbox label="Oui" onChange={()=>setDataSelectedEtablissment({...DataSelectedEtablisement , proprietaire_local : true })} checked={DataSelectedEtablisement.proprietaire_local === true }></Checkbox>
      <Checkbox label="Non" onChange={()=>setDataSelectedEtablissment({...DataSelectedEtablisement , proprietaire_local : false })} checked={DataSelectedEtablisement.proprietaire_local === false}></Checkbox>
      </div>
      </div>
      
     
      
      </>
   
      
            
            <div className="flex justify-center mt-6">

            <button onClick={()=> setAdd(false)}  className="border-[2px] ml-4 p-2 border-white text-white rounded hover:bg-black/70 hover:text-white flex flex-row"><RiArrowGoBackFill  className="text-2xl text-white mr-2"/> Annuler</button>
            </div>
              </div>
             )}
            
  { add === false  && (
    
    <div className="flex justify-center p-4 " >
     
     <div className="flex flex-col">
     <div className=" mt-6 overflow-y-auto w-[1300px] ">
    <Table
  headers={Headersetablissement}
  data={DataEtablissment}
  onClick={handleSelectedDataTableEtablissment}
  selectedRowIndex={selectedRowIndexEtablissement}
  ></Table>
  </div>
  <div className="flex justify-center mt-6">
  <div >
              <button onClick={()=> setAdd(true)} className="border-[2px] p-2 border-white  rounded hover:bg-black/70 hover:text-white "><MdOpenInNew className="text-white"></MdOpenInNew></button>
  </div>
  
  </div>
  <Link to={`/SituationGeographiqueIm`}  className="border-[2px] text-white ml-40 mt-6 mb-6 w-40 p-2 border-white rounded hover:bg-black/70 hover:text-white flex flex-row"><RiArrowGoBackFill  className="text-2xl mr-2"/> Fermer</Link>
     </div>
  </div>
  )} 
       </div>
      </div>
    
    </div></main>
          </div>
    )
  }

export default EtablissementContribuable